<template>
  <div
    v-if="value"
    class="flex-grow d-flex flex-col w-full"
    data-test="image-content"
  >
    <img :src="url" :alt="altText" />
  </div>
</template>

<script>
import { isObject } from '@/utils/generalUtils'

export default {
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
  },
  computed: {
    url() {
      return isObject(this.value) ? this.value.url : this.value
    },
    altText() {
      return isObject(this.value) ? this.value.altText : null
    },
  },
}
</script>
